import React from 'react';
import {ExpressCheckoutButtons} from '@wix/ecom-platform-express-checkout-buttons/widget';
import {useControllerProps} from '../../domain/controllers/ControllerContext';
import {useEnvironment, useExperiments} from '@wix/yoshi-flow-editor';
import {SPECS} from '../../domain/specs';

export const ExpressButtons = ({dataHook, withLoader}: {dataHook: string; withLoader?: boolean}) => {
  const {dynamicPaymentOptionsProps} = useControllerProps().cashierExpressStore;
  const {cartSummary, cartModel} = useControllerProps().cartStore;
  const {isMobile} = useEnvironment();
  const {experiments} = useExperiments();

  const isErrorModalsHandledByLibrary = experiments.enabled(SPECS.DisplayCheckoutErrorModalsForExpressButtons);
  const shouldRequestShipping = dynamicPaymentOptionsProps?.shouldRequestShipping;
  const canCheckout = isErrorModalsHandledByLibrary ? true : dynamicPaymentOptionsProps?.canCheckout;

  return (
    <ExpressCheckoutButtons
      layout={'vertical'}
      withLoader={withLoader}
      isMobile={isMobile}
      currency={cartModel.paymentInfo.currencyCode}
      isShippable={shouldRequestShipping}
      estimatedTotal={cartSummary?.estimatedAmountToPay.toString()}
      canStartPayment={canCheckout}
      theme={dynamicPaymentOptionsProps?.getButtonTheme}
      buttonStyle={dynamicPaymentOptionsProps?.buttonStyle}
      dataHook={dataHook}
    />
  );
};
